export function setGlobalCssVariables(name, value) {
  var _ref;
  var scope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ':root';
  var container = (_ref = document.querySelector(scope)) !== null && _ref !== void 0 ? _ref : document.documentElement;
  container.style.setProperty("--".concat(name.replace(/^--/, '')), value.toString());
}